import {makeReactContext} from 'lib/makeReactContext';
import {MaterialFlow, Method} from 'procedures/ProcedureDomainTypes';
import {ProcessFlowchartValidationError} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import {ProcedurePauseCondition} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/redux/reduceFlowchartConfig';

interface MethodSidepanelContextValue {
  saveImmediately: ((methodUpdater: (currentMethod: Method) => Method) => Promise<void>) | null;
  isSaveInFlight: boolean;
  pauseAutosaver: ((condition: ProcedurePauseCondition, value: boolean) => void) | null;
  flushUnsavedChanges: (() => Promise<void>) | null;
  materialFlows: Array<MaterialFlow>;
  validateBeforeSave: ((draftMethod?: Method) => Array<ProcessFlowchartValidationError>) | null;
}

const MethodSidepanelContext = makeReactContext<MethodSidepanelContextValue>(
  () => ({
    // This context will not be available in legacy procedures; callers can check for null to determine
    // whether to use this saveImmediately or the one provided by ProcedurePageContext
    saveImmediately: null,
    isSaveInFlight: false,
    pauseAutosaver: null,
    flushUnsavedChanges: null,
    materialFlows: [],
    validateBeforeSave: null,
  }),
  'MethodSidepanelContext'
);

export default MethodSidepanelContext;
